import type { useMembershipsChartQuery } from '@fourthwall/module-analytics'
import {
  createAllRangeDates,
  getFromMapByTimestamp,
  mapCurrentDataToTimestampsTotalMembers,
} from '@fourthwall/module-analytics'

import type { AnalyticsParams } from '../../../../../modules/AnalyticsParams'
import type { AnalyticsReportStatsTable } from '../AnalyticsReport.types'

export const createChartStatsTableFreeMembersChange = (
  current:
    | NonNullable<
        ReturnType<typeof useMembershipsChartQuery>['membershipsChartQuery']['data']
      >['current']
    | undefined,
  params: AnalyticsParams,
): AnalyticsReportStatsTable<any>['data'] => {
  if (!current) return []

  const allRangeDates = createAllRangeDates(params).reverse()
  const change = mapCurrentDataToTimestampsTotalMembers('value', current.freeAccountsChange?.data)

  return allRangeDates.map((date) => ({
    id: date,
    day: date,
    change: getFromMapByTimestamp(change, date) || 0,
  }))
}
